import cosSdk from 'cos-js-sdk-v5';
import axios from 'axios';
import { Base64 } from 'js-base64';

const COS = cosSdk;

/**
 * 初始化cos密钥
 * */
function getCOS(cosParams) {
  const obj = {
    TmpSecretId: cosParams.sid,
    TmpSecretKey: cosParams.skey,
    XCosSecurityToken: cosParams.token,
    // StartTime: cosParams.start_time,
    ExpiredTime: cosParams.expiredTime,
    ScopeLimit: true,
  };
  return new COS({
    getAuthorization: (options, callback) => {
      callback(obj);
    },
  });
}

/**
 * 获取后台服务Cos上传权限
 * 权限位置为：user_id/Echar
 * */
function rpcGetUploadTmpCredential(data) {
  return axios({
    method: 'post',
    url: '/api/eda/common/project/getAuthCode',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    const { token, skey, sid, region, path, expiredTime } = JSON.parse(Base64.decode(res.data.data.authCode));
    const bucket = res.data.data.cosPath.substring(0, res.data.data.cosPath.indexOf('/'));
    return { token, path, region, expiredTime, sid, skey, bucket };
  });
}

/**
 * 分片上传文件
 */
export function cosSliceFile(file, data, onProgress) {
  let uploadPercent  = 0;
  return new Promise((resolve, reject) => {
    rpcGetUploadTmpCredential(data).then((cosParams) => {
      const cos = getCOS(cosParams);
      const url = cosParams.path.split('/');
      const cosPath = `${url[1]}/${file.name}`;
      cos.sliceUploadFile({
        Bucket: cosParams.bucket,
        Region: cosParams.region,
        Key: cosPath,
        Body: file,
        SliceSize: 1024 * 1024 * 4,
        onProgress: (progressData) => {
          uploadPercent = parseInt(progressData.percent * 10000) / 100;
          // 如果有进度回调函数，实时调用
          if (onProgress && typeof onProgress === 'function') {
            onProgress(uploadPercent, file.name);
          }
        }
      }, (err, data) => {
        if (err) {
          reject(err);
        } else if (data) {
          resolve(uploadPercent);
        } else {
          reject(new Error('上传失败，未知错误'));
        }
      });
    });
  });
};

/**
 * 上传一个文件至COS指定路径
 * @param file 需要上传的文件
 * @param projectId
 */
export function cosTmpPutObject(file, data) {
  return new Promise((resolve, reject) => {
    rpcGetUploadTmpCredential(data).then((cosParams) => {
      const cos = getCOS(cosParams);
      const url = cosParams.path.split('/');
      const cosPath = `${url[1]}/${file.name}`;
      cos.putObject({
        Bucket: cosParams.bucket,
        Region: cosParams.region,
        Key: cosPath,
        Body: file,
        SliceSize: 1024 * 1024,
      }, (err, data) => {
        if (err !== null) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  });
}

/**
 * 封装cos常用选项，不新增option内容
 * @param cosParams cos参数
 */
function cosOption(cosParams) {
  const index = cosParams.path.indexOf('/');
  const url = cosParams.path.substring(index + 1, cosParams.path.length);
  const { bucket, region } = cosParams;
  const obj = {
    Bucket: bucket,
    Region: region,
  };
  return {
    option: obj,
    cos: getCOS(cosParams),
    cosPath: `${url}/`,
  };
}

/**
 * 获取桶下的对象列表
 */
export async function cosGetBucket(data) {
  const cosParams = await rpcGetUploadTmpCredential(data);
  const { option, cos, cosPath } = cosOption(cosParams);
  option.Prefix = cosPath;
  return getBucket(option, cos);
}

function getBucket(option, cos) {
  return new Promise((resolve, reject) => {
    cos.getBucket(option, (err, data) => {
      if (err) {
        reject(err);
      } else {
        resolve(data);
      }
    });
  });
}

/**
 * cos get请求
 * @param cos
 * @param option
 */
function getCosObject(cos, option) {
  return new Promise((resolve, reject) => {
    cos.getObject(option, (err, data) => {
      if (err) {
        reject(err);
      } else {
        resolve(data);
      }
    });
  });
}

/**
 * 下载一个对象
 * @param fileName 下载的文件名
 */
export function cosGetObject(fileName, data) {
  return rpcGetUploadTmpCredential(data).then((cosParams) => {
    const { option, cos, cosPath } = cosOption(cosParams);
    option.Key = `${cosPath}${fileName}`;
    option.DataType = 'arraybuffer';
    return getCosObject(cos, option);
  }).catch((err) => {
    console.log(err, 'err');
  });
}

/**
 * 删除COS上的指定文件
 * @param fileName 需要删除的文件名
 */
export async function cosDeleteObject(fileName, data) {
  const cosParams = await rpcGetUploadTmpCredential(data);
  const { cos, cosPath } = cosOption(cosParams);

  const params = {
    Bucket: cosParams.bucket,
    Region: cosParams.region,
    Key: cosPath + fileName,
  };

  return new Promise((resolve, reject) => {
    cos.deleteObject(params, (err, data) => {
      if (data) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}
